module.exports = __webpack_public_path__ + "static/media/traffic-no.4ec81564.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nxbus/traffic-no.svg
// module id = 779
// module chunks = 0